module.exports = __webpack_public_path__ + "img/FilesMedia.6b879fd5.svg";